import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authAPI } from '../services/api';
import { Button } from '../components/Common/Button';
import { PasswordInput } from '../components/Common/PasswordInput';
import { LoginBack, LoginHeader, Advice } from '../components/Common/Card';
import { Pass_Key, Check } from '../components/Icons/CustomIcons';
import { GoToDialog, FormLabel, IconContainer, AuthDesktopHeader } from '../components/Common/Dialog';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [newPassword, setNewPassword] = useState('');
  const [status, setStatus] = useState('idle'); // 'idle' | 'loading' | 'success' | 'error'
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const returnTo = '/';

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setError('Kein Reset-Token gefunden. Bitte klicken Sie erneut auf den Link in Ihrer E-Mail.');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword.length < 8) {
      setError('Das Passwort muss mindestens 8 Zeichen lang sein.');
      return;
    }

    setStatus('loading');
    try {
      await authAPI.resetPassword(token, newPassword);
      setStatus('success');
    } catch (err) {
      const msg = err.response?.data?.error || 'Fehler beim Zurücksetzen des Passworts.';
      setError(msg);
      setStatus('error');
    }
  };

  const bgStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/GrosselternMitKindern.png)`,
  };

  return (
    <>
    <div className="auth-fullpage" style={bgStyle}>
      <LoginBack returnTo={returnTo} />
      <div>   
        <span className="auth-fullpage-mobile-only"><IconContainer Icon={Pass_Key} /></span>
        <LoginHeader
          title="Neues Passwort festlegen"
          subtitle="Geben Sie Ihr neues Passwort ein."
        /> 
      </div>
      <div className="auth-fullpage-panel">
        <AuthDesktopHeader
          title="Neues Passwort festlegen"
          subtitle="Geben Sie Ihr neues Passwort ein, um Ihr Konto zu sichern."
        />
        <div className="auth-panel-body">
          {error && (
            <div className="error-message" role="alert" style={{ marginBottom: 'var(--spacing-4)' }}>
              {error}
              {status === 'error' && error.includes('abgelaufen') && (
                <button
                  type="button"
                  className="ml-resend-btn"
                  style={{ display: 'block', marginTop: 'var(--spacing-2)' }}
                  onClick={() => navigate('/passwort-vergessen')}
                >
                  Neuen Reset-Link anfordern
                </button>
              )}
            </div>
          )}

          <form onSubmit={handleSubmit} className="ml-form">
            <div className="ml-field">            
              <FormLabel htmlFor="new_password">Neues Passwort</FormLabel>
              <PasswordInput
                id="new_password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                autoComplete="new-password"
                required
                autoFocus
              />
              <p className="body Font-S-I-130-T Colors-Grey-06">Mindestens 8 Zeichen, ein Großbuchstabe, ein Kleinbuchstabe und eine Zahl.</p>
              <Advice text="Bitte geben Sie Ihr Passwort sorgfältig ein. Sie können es jederzeit ändern." />
            </div>
            <Button
              type="submit"
              className="w-full"
              disabled={status === 'loading' || !token}
            >
              {status === 'loading' ? 'Wird gespeichert…' : (
                <>
                  <Check size={28} aria-hidden="true" style={{ marginRight: '0.5rem' }} />
                  Passwort speichern
                </>
              )}
            </Button>
          </form>
        </div>
      </div>
    </div>

    {/* Erfolgs-Popup nach Passwort-Reset */}
    {status === 'success' && (      
        <GoToDialog
          icon={Pass_Key}
          title="Fertig!"
          text="Zur Anmeldung"
          message="Ihr Passwort wurde geändert."
          onConfirm={() => navigate('/anmelden')}
        />
    )}
    </>
  );
};

export default ResetPassword;

